import { CenteredText } from 'ui/components';

export const CenteredTextFeature: React.FC<Content.CenteredText> = ({ content }) => <CenteredText {...content?.properties} />;



